import cash_booking from "../assests/images/master/cash-booking-ratecard.svg";

export const reportPaths = [
  {
    id: 1,
    parentId: 5,
    parentHeading: "MIS Reports",
    imgSrc: cash_booking,
    title: "Delivery MIS Report",
    route: "/delivery-mis-report",
    disable: false,
  },
  {
    id: 2,
    parentId: 5,
    parentHeading: "MIS Reports",
    imgSrc: cash_booking,
    title: "Delivery MIS Report (NEW)",
    route: "/delivery-mis-report-new",
    disable: false,
  },
];
